import theme from 'assets/theme/theme';

const styles = () => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(1)
    },
    topContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
        marginBottom: '5px'
    },
    informationContainer: {
        height: '85%',
        width: '100%'
    },
    noRecordsFoundContainer: {
        height: '85%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '30px',
        fontWeight: 'bold',
        color: theme.palette.grey.main
    },
    loaderContainer: {
        width: '100%',
        height: '85%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    button: {
        height: '60%'
    },
    formControl: {
        margin: '0px auto 0px 5px'
    },
    leftIcon: {
        marginRight: '4px',
        fontSize: 20
    },
    datePicker: {
        margin: '5px'
    }
});

export default styles;
